<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/products_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>口腔保健用品專區</h1>
          <div class="banner-text-line"></div>
          <span>Oral Health Products Zone</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <div class="content-title">
          <h2>口腔保健用品專區</h2>
          <div class="bread">
            <router-link to="/">
              <i class="fas fa-home fa-lg"></i>
            </router-link>
            <span>></span>
            口腔保健用品專區
          </div>
        </div>
        <div
          class="content-textBox"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
        >
          <ul
            class="content-products"
            v-if="prdocutsList && prdocutsList.length > 0"
          >
            <li
              class="card-products"
              v-for="item in prdocutsList"
              :key="item.Id"
            >
              <a :href="item.Url" target="_blank" rel="noreferrer noopener">
                <img
                  class="card-products-img img-fluid"
                  :src="item.Picture"
                  :alt="item.Title"
                />
                {{ item.Title }}
              </a>
            </li>
          </ul>
          <div class="content-contact" v-else>
            <div class="content-contact-border">
              <div class="member-box">
                <h3>目前沒有內容</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productApi from '@/assets/api/product';
import BG from '../assets/images/index_bg_big.png';
// 圖檔暫時 import 區
// import ProductsIMG from '../assets/images/products.jpg';

export default {
  name: 'Products',
  data() {
    return {
      BG,
      prdocutsList: [
        // {
        //   imgSrc: ProductsIMG,
        //   title: '3M 雙線牙線棒-2盒+3包量販包',
        //   linkUrl: 'https://www.google.com',
        // },
        // {
        //   imgSrc: ProductsIMG,
        //   title: '3M 兒童牙線棒杯裝(55支x5入組)',
        //   linkUrl: 'https://www.google.com',
        // },
        // {
        //   imgSrc: ProductsIMG,
        //   title: '3M 3效漱口水薄荷味(120MLx12入)',
        //   linkUrl: 'https://www.google.com',
        // },
        // {
        //   imgSrc: ProductsIMG,
        //   title: '3M 雙線牙線棒-2盒+3包量販包',
        //   linkUrl: 'https://www.google.com',
        // },
        // {
        //   imgSrc: ProductsIMG,
        //   title: '3M 兒童牙線棒杯裝(55支x5入組)',
        //   linkUrl: 'https://www.google.com',
        // },
      ],
      nowPage: 1,
      busy: false, // true觸發載入，false停止載入
      totalPage: 1,
    };
  },
  methods: {
    getProduct(page) {
      const vm = this;
      productApi.getAllProduct(page).then((res) => {
        if (res.status === 200) {
          if (vm.prdocutsList.length === 0) {
            vm.prdocutsList = res.data.Data.Products;
            vm.totalPage = Math.ceil(parseInt(res.data.Data.Total, 10) / 10);
          } else {
            vm.busy = false;
            vm.$store.dispatch('updateLoading', false);
            vm.prdocutsList = vm.prdocutsList.concat(res.data.Data.Products);
          }
        } else {
          vm.$swal({
            icon: 'warning',
            text: res.data.Message,
            confirmButtonText: '確定',
          }).then(() => {
            vm.$router.push('/');
          });
        }
      });
    },
    loadMore() {
      const vm = this;
      vm.busy = true;
      if (
        vm.totalPage === 0
        || vm.totalPage === 1
        || vm.totalPage === vm.nowPage
      ) {
        vm.busy = false;
      } else {
        vm.$store.dispatch('updateLoading', true);
        vm.nowPage += 1;
        vm.getProduct(vm.nowPage);
      }
    },
  },
  created() {
    const vm = this;
    vm.getProduct(vm.nowPage);
  },
};
</script>
